import React, { useContext } from 'react';

import { TitleContainer, TitleWrapper, Author } from './PlayerTitle.styles';
import { NowPlayingContext } from '../../../contexts/now-playing.context';
import { PlayerContext } from '../../../contexts/player.context';

const PlayerTitle = () => {
  const { nowPlaying } = useContext(NowPlayingContext);
  const { title, thumbnail, author, authorId } = nowPlaying;

  const { minimized } = useContext(PlayerContext);

  return (
    <TitleContainer minimized={minimized}>
      <img src={thumbnail} alt="Podcast Thumbnail" />
      <TitleWrapper>
        <h4>{title}</h4>
        {!minimized && <Author to={`/podcast/${authorId}`}>{author}</Author>}
      </TitleWrapper>
    </TitleContainer>
  );
};

export default PlayerTitle;
